import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-upload";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
class Resource extends BaseViewModel {
    ResourceTypeId: KnockoutObservable<string> = ko.observable<string>(null);
    ResourceId: KnockoutObservable<string> = ko.observable<string>(null);
    ResourceUploadEnabled: KnockoutObservable<boolean> = ko.observable(true);
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SearcherType = {
            SearchType: "Checkware-ResourceType",
            ObjectId: this.ResourceTypeId,
            ObjectValue: "Key",
            AutoComplete: true
        };
    }
    SearcherType: Bindings.baoSearcher;
    Save() {
        return super.Save().then(() => {
            return this.UploadResource();
        });
    }
    Download() {
        window.open(Bao.Content("Resource/Download/" + this.ResourceId()), '_blank');
    }
    ;
    UploadResource() {
        //dummy
    }
    ;
    CompleteCheck() {
        return true;
    }
    InitUrl() {
        return "Resource/Init";
    }
    loaded() {
        super.loaded();
    }
}
export default Resource;